export var CHEVRON_RIGHT_ICON = 'chevron-right';
export var ANGLE_DOWN_ICON = 'angle-down';
export var SLIDE_ANIMATION_DURATION = 500;